import { createSelector } from 'reselect';

export const timeSlotChatDomainSelector = state => state.timeSlotChat;

export const timeSlotChatValueSelector = createSelector(
  timeSlotChatDomainSelector,
  subState => subState.value,
);

export const timeSlotChatTextSelector = createSelector(
  timeSlotChatDomainSelector,
  subState => subState.text,
);

/**
 * Возвращает флаг true|false если есть выбранный интервал времени онлайн-чата
 */
export const onlineChatSelectedSelector = createSelector(
  timeSlotChatTextSelector,
  subState => !!subState,
);

